<h3>Cirugías</h3>
<p>Busca y selecciona las cirugías que requiere el paciente</p>
<soph-multi-select-search-form-field
  [formGroup]="formOperaciones"
  controlName="operaciones"
  placeholder="Seleccionar cirugía"
  [values]="operacionesOptions"
  [limitValues]="50"
  idField="idOperacion"
  viewField="nombre"
>
</soph-multi-select-search-form-field>
<div *ngIf="operaciones.value && operaciones.value.length > 0" class="selected-items">
  <h3>Cirugías seleccionadas</h3>
  <div class="form-section-grupo" *ngFor="let operacion of operacionesSelected; index as i">
    <mat-divider></mat-divider>
    <mat-accordion class="full-width custom-accordion">
      <mat-expansion-panel [expanded]="formOperaciones.get('operaciones')?.enabled">
        <mat-expansion-panel-header [collapsedHeight]="'auto'" [expandedHeight]="'auto'">
          <mat-panel-title class="style-tittle-colapse">
            {{ operacion.codigo + ' ' + operacion.nombre }}
          </mat-panel-title>
        </mat-expansion-panel-header>
        @if(!this.formOperaciones.get('operaciones')?.disabled) {
        <div class="section-eliminar">
          <button mat-button (click)="unselectOperacion(operacion.idOperacion)">
            <mat-icon svgIcon="trash"></mat-icon>
            Eliminar
          </button>
        </div>
        }
      </mat-expansion-panel>
    </mat-accordion>
    <mat-divider *ngIf="i === operacionesSelected.length - 1"></mat-divider>
  </div>
</div>
<!-- operacions guardados -->
<!-- @if(operacionesGuardados.length > 0) {
<div class="parent-container">
  <div class="container-remedios">
    @for(operacion of operacionesGuardados; track operacion.idOperacion){
    <div class="remedio-guardado">
      {{ operacion.codigo + ' ' + operacion.nombre }}
    </div>
    }
  </div>
</div>
} -->
